module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Company",
      "visible": _vm.addDisplayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.addDisplayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addTicketDetails.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-primary",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewTicketDetails.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "source"
    }
  }, [_vm._v("Source")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "source",
      "options": _vm.sourceList,
      "optionLabel": "value",
      "placeholder": "Select Source"
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "pipeline"
    }
  }, [_vm._v("Pipeline"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "pipeline"
    },
    model: {
      value: (_vm.pipeline),
      callback: function($$v) {
        _vm.pipeline = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "pipeline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "ticketStatus"
    }
  }, [_vm._v("Ticket Status")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "ticketStatus",
      "options": _vm.ticketStatusList,
      "optionLabel": "value",
      "placeholder": "Select Ticket Status"
    },
    model: {
      value: (_vm.ticketStatus),
      callback: function($$v) {
        _vm.ticketStatus = $$v
      },
      expression: "ticketStatus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "description",
      "rows": "3"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "priority"
    }
  }, [_vm._v("Priority")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "priority",
      "options": _vm.priorityList,
      "optionLabel": "value",
      "placeholder": "Select Priority"
    },
    model: {
      value: (_vm.priority),
      callback: function($$v) {
        _vm.priority = $$v
      },
      expression: "priority"
    }
  })], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3601b6ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crmDialog/crmTicketDetailsDialog.vue
// module id = 2142
// module chunks = 0